export default __webpack_public_path__ + "static/media/back.24c5536a.png";